/**
 * The fields of a waiting gate's payload the gate card draws an input for (#433): each field the gate names editable
 * (`editableFields`, the list `GatesService.decide` enforces) that the run wrote as text, in the order the run wrote
 * them. The API accepts a named field whatever its value, but the card edits text: typing into an input would turn a
 * number or a list into a string the tool never received, so such a field is shown as the run wrote it.
 *
 * Empty when the payload is not an object of fields, or holds no named field as text: the card then has nothing to
 * edit, and says what Approve runs without offering an edit (`GateDecisionActions`).
 */
export function textFieldsToEdit(payload: unknown, editableFields: readonly string[]): string[] {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        return []
    }
    const fields = payload as Record<string, unknown>
    return Object.keys(fields).filter(field => editableFields.includes(field) && typeof fields[field] === 'string')
}
